import React from 'react';
import { IMotorhomeTabs, IMotorhomeTabsTitles } from '../MotorhomeDetails';

export const MotorhomeSpecificationsTabPanel = ({ tab }: { tab: IMotorhomeTabs }) => {
    if (!tab?.specifications) {
        return;
    }
    return (
        <div id={tab.name} title={tab.title}>
            <h5 className="mb-6 capitalize">{IMotorhomeTabsTitles.Specifications}</h5>
            <div className="grid gap-0 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4">
                {Object.entries(tab?.specifications).map(([key, value]) => (
                    <li key={key} className="mb-4 whitespace-nowrap list-none">
                        <span className="font-semibold">{key}</span>: {value}
                    </li>
                ))}
            </div>
        </div>
    );
};
